import React from 'react';
import PropTypes from 'prop-types';
import inflection from 'inflection';
import translate from 'components/hoc/translate';

const FieldTitle = (props) => {
    const { resource, source, label, translate } = props;

    /**
     * Option 1: label
     * If the label exists. We will translate this.
     */
    if (label) {
        return (
            <span>
                { translate(label, { _: label }) }
            </span>
        );
    }

    /**
     * Option 2: source
     * What it the source exists, we will use this one.
     */
    if (source) {
        return (
            <span>
                { translate(`resources.${ resource }.fields.${ source }`, { _: inflection.humanize(source) }) }
            </span>
        );
    }

    /**
     * Option 3: eventually
     * If none exists we will return nothing.
     */
    return null;
};

FieldTitle.propTypes = {
    resource: PropTypes.string,
    source: PropTypes.string,
    label: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default translate(FieldTitle);



// WEBPACK FOOTER //
// ./src/components/aor/FieldTitle.js